import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';

import Security from './Security';
import Validator from '../../components/Validator';
import Modal from '../../components/Modal';

import {
  newNextAction,
} from '../../actions/navigation';

// Configuration & Assets
import schema from './securitySchema';
import imgError from '../../assets/images/error.svg';
import './style.scss';

const SecurityError = (props) => {
  const { dispatch, params, searchParams } = props;
  const workflowType = get(params, 'workflowType') || 'text2apply';
  const key = searchParams.get('key');

  const handleButtonClick = (e) => {
    e.preventDefault();

    dispatch(newNextAction({
      key,
      workflowType,
      data: {
        allowContinue: true,
      },
    }));
  };

  return (
    <div>
      <Security />
      <Modal>
        <div className="card-content error-modal security-error">
          <img src={imgError} alt="" />
          <p>
            Please retake the photo of
            <br />
            {' '}
            the back of your license.
          </p>
          <div onClick={handleButtonClick} className="btn btn-red">OK</div>
        </div>
      </Modal>
    </div>
  );
};

SecurityError.propTypes = {
  dispatch: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired,
  searchParams: PropTypes.object.isRequired,
};

export default Validator(schema)(connect(null)(SecurityError));
